// extracted by mini-css-extract-plugin
module.exports = {"loadingPlaceHolder":"SingleSelectFilter_loadingPlaceHolder__3DCEJ","loader":"SingleSelectFilter_loader__1uAIK"};